import { ENV_CONFIG } from '../../../__config__/env';
import * as React from 'react';
import { Redirect, useHistory, useLocation, useRouteMatch } from 'react-router';
import styled, { createGlobalStyle } from 'styled-components';
import { animated } from 'react-spring';

import { useFadeTransition } from '../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../utils/seo/Index';

import { Container } from '../../layout/Container';
import { Heading } from '../../ui/text/Heading';
import { Logo } from '../../ui/logo/office/Index';
import { useQuery } from '@apollo/client';

import { STILLING_QUERY } from '../../../../client/__graphql__/queries';
import { mapStyles } from './mapStyles';
/* import { useMap } from '../../../utils/hooks/useMap'; */
import { SiteContext } from '../../../utils/context/SiteContext';
import { Hero } from '../../ui/hero/Index';

import NoMatch from '../404Old';

const Stilling: React.FC<any> = () => {
  const location = useLocation();
  const match = useRouteMatch<{ slug: string }>();

  /*   const context: any = React.useContext(SiteContext);
  useMap(); */

  const { data, loading, error } = useQuery(STILLING_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        slug: match?.params.slug
      }
    }
  });

  /*   React.useEffect(() => {
    if (
      window &&
      window.google &&
      data?.getPosition?.office?.lat &&
      data?.getPosition?.office?.lon
    ) {
      const settings = {
        disableDefaultUI: true,
        zoomControl: true,
        zoom: 14,
        styles: mapStyles
      };

      const center = {
        lat: Number(data?.getPosition?.office?.lat),
        lng: Number(data?.getPosition?.office?.lon)
      };

      if (!window.gmap) {
        window.gmap = new window.google.maps.Map(
          document.getElementById('map'),
          {
            ...settings,
            center
          }
        );
        new window.google.maps.Marker({
          position: center,
          map: window.gmap
        });
      }
    }
  }, [context?.contextData?.google, data?.getPosition]); */

  const { fadeIn: pageFadeIn } = useFadeTransition({
    loaded: !loading
  });

  if (error?.graphQLErrors?.map((item: any) => item.extensions?.code === 404)) {
    return <NoMatch />;
  }

  const descriptions: Record<number, string> = {
    68: 'PrivatMegleren Ålesund søker fagansvarlig.',
    60: 'PrivatMegleren Larvik søker nå etter en eiendomsmegler.',
    64: 'PrivatMegleren Valdres søker medhjelper - backoffice.'
  };

  return (
    <>
      <GlobalStyles />
      <Seo
        title={`${data?.getPosition?.title} ${data?.getPosition?.office?.name}`}
        description={descriptions[data?.getPosition?.id] || 'Ledige stillinger'}
        image={`${ENV_CONFIG.CDN_HOST}privatmegleren/Visuell-3_Stolt-compressed.jpg`}
        url={`https://privatmegleren.no/${location.pathname}`}
      />
      <Hero
        style={{ ...pageFadeIn }}
        className="content-height padding-top-150"
        imageUrl={`${ENV_CONFIG.CDN_HOST}privatmegleren/Visuell-3_Stolt-compressed.jpg`}
        opacity={1}
        alt="bilde"
      >
        <TopContent>
          {/* Må gjøres en sjekk på id om PM ønsker stor bokstav i første ordet. */}
          <Heading
            style={{ paddingBottom: '16px' }}
            tag="h1"
            center={true}
            color="champagne"
          >
            {data?.getPosition?.title}
          </Heading>

          {/* <h1 dangerouslySetInnerHTML={{ __html: data?.getPosition?.title }} /> */}
          <Info dangerouslySetInnerHTML={{ __html: data?.getPosition?.info }} />
        </TopContent>
      </Hero>
      <Container
        style={{ minHeight: '100%', paddingTop: '50px', ...pageFadeIn }}
      >
        {data?.getPosition?.ingress ? (
          <>
            <Content
              className="ingress"
              dangerouslySetInnerHTML={{ __html: data?.getPosition?.ingress }}
            />
            <ContentLine>
              <span className="line" />
            </ContentLine>
          </>
        ) : null}
        {/*         <MapWrapper>
          <Map id="map" />
        </MapWrapper> */}
        <Content
          dangerouslySetInnerHTML={{
            __html: data?.getPosition?.content
          }}
        />
        <ContentLogo>
          <Logo name={data?.getPosition?.office?.name} alt="bilde av logo" />
        </ContentLogo>
      </Container>
    </>
  );
};

export default Stilling;

const GlobalStyles = createGlobalStyle`
    .footer {
        margin-top: 0;
    }
`;

const TopContent = styled(animated.div)`
  position: relative;
  top: -2em;
  @media all and (min-width: 600px) {
    display: flex;
    flex-flow: column;
    width: 100%;
    padding: 0 30px;

    h1 {
      margin-bottom: 0;
      width: 100%;
      word-break: break-word;
    }

    h2 {
      width: 100%;
      word-break: break-word;
    }
    .position-info {
      color: ${({ theme }) => theme.colors.champagne};
      text-align: center;
    }
    .firstLetterKondo {
      font-family: 'Kondo', sans-serif;
    }
  }
`;

const Content = styled.div`
  width: 100%;
  padding: 0 20px 20px 20px;

  &.ingress {
    text-align: center;
  }

  p {
    word-break: break-word;
  }

  ul {
    color: white;
    li {
    }
  }
`;

const ContentLogo = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 50px;
`;

const MapWrapper = styled.div`
  padding: 0 10px;
`;

const Map = styled.div`
  width: 100%;
  height: 300px;
  margin: 0 0 50px 0;
  background: rgb(20, 20, 20);
`;

const Info = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 20px;
  span {
    color: ${({ theme }) => theme.colors.champagne};
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
  }
`;

const ContentLine = styled.div`
  padding: 0 10px;
  margin-bottom: 40px;

  .line {
    display: block;
    border-bottom: solid 1px ${({ theme }) => theme.colors.primary};
  }
`;
